import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { loadFacebookPixel } from "@/utils/metaPixel";

const STORAGE_KEY = "gps_cookie_consent";

export const OPEN_COOKIE_PREFERENCES_EVENT = "gps:open-cookie-preferences";

type Consent = "accepted" | "declined";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored: Consent | null = null;
    try { stored = localStorage.getItem(STORAGE_KEY) as Consent | null; } catch {
      // Navegadores que bloqueiam armazenamento ainda podem exibir a página.
    }
    if (stored === "accepted") {
      loadFacebookPixel();
      return;
    }
    if (stored === "declined") return;
    setVisible(true);
  }, []);

  // Permite reabrir o banner a partir de um link "Preferências de Cookies"
  // no rodapé, mesmo depois que o usuário já escolheu aceitar/recusar.
  useEffect(() => {
    const openBanner = () => setVisible(true);
    window.addEventListener(OPEN_COOKIE_PREFERENCES_EVENT, openBanner);
    return () => window.removeEventListener(OPEN_COOKIE_PREFERENCES_EVENT, openBanner);
  }, []);

  const handleChoice = (consent: Consent) => {
    try { localStorage.setItem(STORAGE_KEY, consent); } catch {
      // A escolha continua válida durante esta visita.
    }
    if (consent === "accepted") loadFacebookPixel();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white p-4 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:p-5">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 sm:flex-row sm:justify-between sm:gap-6">
        <p className="text-sm text-gray-600">
          Usamos cookies para melhorar sua experiência. Saiba mais na nossa{" "}
          <Link to="/privacidade" className="font-semibold text-gps-medium-blue hover:underline">
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex w-full shrink-0 gap-2 sm:w-auto">
          <Button
            variant="outline"
            className="flex-1 sm:flex-none"
            onClick={() => handleChoice("declined")}
          >
            Recusar
          </Button>
          <Button
            className="flex-1 bg-gps-dark-blue text-white hover:bg-gps-medium-blue sm:flex-none"
            onClick={() => handleChoice("accepted")}
          >
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
